<template>
    <section v-if="json" class="page-project">
        <div class="capper">
            <div class="capper-padded">
                <div class="top">
                    <div class="rte no-max-width">
                        <h1 v-html="getDisplayTitle"></h1>
                        <div v-if="json.topBlurb" class="copy" v-html="json.topBlurb"></div>
                    </div>
                </div>
            </div>
        </div>
        <GridOuter v-if="json.grid" :json="json.grid" section=project></GridOuter>
    </section>
</template>
<script>
import axios from 'axios'
import gh from '@/helpers/gh'
import GridOuter from "@/components/blocks/GridOuter.vue";
export default {
    name: "ProjectPage",
    components: {
        GridOuter,
    },
    data () {
        return {
            window: window,
            json: null,
            transition: false,
            gh: gh
        }

    },
    created () {
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        axios.get((`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((e) => {
                console.error('Error',slug,e)
        })
    },
    computed: {
        getDisplayTitle() {
            let title = this.json.title
            if (this.json.displayTitle) {
                title = this.gh.removeTags(this.json.displayTitle)
            }
            return title
        }
    },
    methods: {
        reveal () {

        },
        unreveal () {

        },

    }
}
</script>
